import Game from "../../Game.js";
import Styler from "../../maze/featurer/Styler.js";
import Spran from "../spran/Spran.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";

export default class Chest extends Mob {
	constructor(sprites, cell, type = 0, chestIndex = 0) {
		super(sprites, Chest.ANIMATIONS);
		this.width = Game.CHEST_WIDTH;
		this.height = Game.CHEST_HEIGHT;
		this.type = type;
		this.cellOccupied = cell;
		cell.blocked = true;
		cell.chest = true;
		this.opened = false;
		this.chestIndex = chestIndex;

		let traits = {
			clas: "chest",
			openDoors: false,
			static: true,
			qi: BasicAI.QI_NONE,
			speed: Mob.WALK_STEP * Game.MULT,
			radius: Mob.RADIUS,
			runspeed: Mob.RUN_STEP * Game.MULT
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-static").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}


	initSprites() {
		// Setta la grandezza dello sprite
		this.clip = jQuery(".js-sprite", this.mc);

		this.clip.width(Game.CHEST_WIDTH);
		this.clip.height(Game.CHEST_HEIGHT);

		// Lo posiziona, centrato orizzontalmente e appoggiato al bottom verticalmente
		//this.clip.css("left", (this.mc.width() - this.clip.width()) / 2);
		//this.clip.css("top", -(Game.TILE_WIDTH - this.mc.height()) - Game.TILE_WIDTH + Game.HERO_HEIGHT / 2);
		this.spran = new Spran(this.sp, this.clip, this.animationsDefinitions);
		this.spran.init();
		this.setAnimation("closed");

	}


	isOpened() {
		return this.opened;
	}

	open() {
		this.setAnimation("opened");
		this.opened = true;
		return []
	}
	close() {
		this.setAnimation("closedoff");
		this.opened = false;
	}

	setInView(lFlag) {
		if (lFlag) {
			this.spran.resume();
			this.inView = true;
		} else {
			this.spran.pause();
			this.inView = false;
		}
	}

}

Chest.ANIMATIONS = [
	{
		id: "closedoff",
		sheet: Styler.CHESTS,
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "closed",
		sheet: Styler.CHESTS,
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: 1000
			},
			{
				row: 1,
				col: 0,
				time: 180
			},
			{
				row: 2,
				col: 0,
				time: 180
			},
			{
				row: 3,
				col: 0,
				time: 180
			},
			{
				row: 4,
				col: 0,
				time: 180
			},
		]
	},
	{
		id: "opened",
		sheet: Styler.CHESTS,
		flip: false,
		frames: [
			{
				row: 0,
				col: 1,
				time: -1
			}
		]
	},
]